import React from 'react';
import COLORS from '../../constants/colors';
import ProductAttributeSet from '../../components/ProductAttributeSet';
import ProductAttribute from '../../components/ProductAttribute';
import SectionTitle from '../../components/SectionTitle';
import ecommerceIcon from './assets/ecommerce.png';

const ecommerceDescription = (
  <span>
    An ecommerce page is essential for selling online. The easier you make it
    for your users, the more they'll buy and come back for more. A friendly
    visual design will make it even easier for your users.
  </span>
);

function ProductEcommerce({ color }) {
  return (
    <div>
      <SectionTitle color={color}>
        ECOMMERCE&nbsp;
        <span style={{ color: COLORS.PURPLE }}> &#x25CF;</span>
      </SectionTitle>
      <ProductAttributeSet>
        <div className="row">
          <ProductAttribute
            icon={ecommerceIcon}
            title="ECOMMERCE"
            description={ecommerceDescription}
          />
        </div>
      </ProductAttributeSet>
    </div>
  );
}

export default ProductEcommerce;



// WEBPACK FOOTER //
// ./src/components/ProductEcommerce/index.js